import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Eyebrow } from './ui/Eyebrow';
import { faqs, WHATSAPP_URL } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  return <section className="border-b border-line bg-sand" data-id="element-58" data-mp="1bmvcau8f62pn">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-59" data-mp="1gkn6juwje0x0">
        <div className="grid gap-12 lg:grid-cols-[0.7fr_1.3fr] lg:gap-20" data-id="element-60" data-mp="249g41vst4gtq">
          <div data-id="element-61" data-mp="24bk585zbn1qb">
            <Eyebrow data-id="element-62" data-mp="28arto1bol21x">Preguntas frecuentes</Eyebrow>
            <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-63" data-mp="28a9rko2c7tm3">
              Antes de decidir
            </h2>
            <p className="mt-5 text-[15px] leading-relaxed text-ink-soft" data-id="element-64" data-mp="1zi7vf1zawzhm">
              ¿Te quedó otra duda?{' '}
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="font-semibold text-accent underline decoration-accent/40 underline-offset-4 transition-colors duration-150 ease-out hover:text-accent-dark" data-id="element-65" data-mp="2n7sdlinmrspu">
                Escribinos por WhatsApp
              </a>{' '}
              y te responde un asesor.
            </p>
          </div>

          <ul className="divide-y divide-line border-y border-line" data-id="element-66" data-mp="1emeq0vahwdw5">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <li key={faq.question} data-id="element-67" data-mp="1ohq379699d1s" data-mpi={index}>
                  <h3 data-id="element-68" data-mp="1jk6q4clan6bf">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? -1 : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-69" data-mp="1jkzpgshxatjj">
                      <span className="font-display text-lg font-semibold leading-snug text-ink" data-id="element-70" data-mp="3udsrinlp371v">
                        {faq.question}
                      </span>
                      <span aria-hidden="true" className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-line bg-paper text-ink-soft" data-id="element-71" data-mp="237egjweaxods">
                        {isOpen ? <MinusIcon className="h-3.5 w-3.5" data-id="element-72" data-mp="2h88qijgzzxek" /> : <PlusIcon className="h-3.5 w-3.5" data-id="element-73" data-mp="2m725kgbxnwgu" />}
                      </span>
                    </button>
                  </h3>
                  {isOpen && <div id={`faq-panel-${index}`} className="pb-6 pr-12" data-id="element-74" data-mp="2vwvflcwfg3iz">
                      <p className="max-w-prose text-[15px] leading-relaxed text-ink-soft" data-id="element-75" data-mp="2vyy4ftlufqm4">
                        {faq.answer}
                      </p>
                    </div>}
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}